import { render, staticRenderFns } from "./IconBase.vue?vue&type=template&id=27674582&scoped=true"
import script from "./IconBase.vue?vue&type=script&lang=ts"
export * from "./IconBase.vue?vue&type=script&lang=ts"
import style0 from "./IconBase.vue?vue&type=style&index=0&id=27674582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27674582",
  null
  
)

export default component.exports